import { useVvsBoostWeb3React } from 'hooks/useContract'
import { QueryKey } from 'config/constants/queryKey'
import { useQuery, UseQueryOptions } from 'react-query'
import useActiveWeb3React from 'hooks/useActiveWeb3React'

export const useBoostTokenBalanceOfUser = (queryOptions?: Partial<Pick<UseQueryOptions, 'enabled'>>) => {
  const vvsBoostContract = useVvsBoostWeb3React()
  const { account } = useActiveWeb3React()
  return useQuery(
    [QueryKey.VVS_BOOST_BALANCE_OF_INFO, account],
    async () => {
      if (!account) return 0
      const res = await vvsBoostContract.balanceOf(account)

      return res
    },
    {
      enabled: !!account && (queryOptions?.enabled ?? true),
      ...queryOptions,
    },
  )
}
